import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import { AuthProvider } from '@/contexts/AuthContext';
import Portfolio from "@/components/Portfolio";

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
